import { useDispatch } from "react-redux";
import { setCurrentlyOpenModal } from "../../redux";
import ConfirmActionDialog from "../ConfirmActionDialog/ConfirmActionDialog";

export function ConfirmReturnToFileSelection({ open, OKAction }) {
  const dispatch = useDispatch();
  const message = `Are you sure you want to return`;
  return (
    <ConfirmActionDialog
      open={open}
      message={message}
      title="Have you finished?"
      onClose={() => dispatch(setCurrentlyOpenModal(""))}
      OKAction={OKAction}
      OKText="Discard changes"
      cancelText="Cancel"
    />
  );
}
